import { Injectable } from '@angular/core';
import { DurationDetails, DurationValue, SchemaField } from '../../store/models';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class DurationService {
  constructor(private translateService: TranslateService) { }

  getDurationDetails(duration: DurationValue): DurationDetails {
    const m = moment.duration(duration.value, 'seconds');
    return { uId: duration.uId, days: Math.floor(m.asDays()), hours: m.hours(), minutes: m.minutes() };
  }

  getDurationDetailsFromValue(value: number): DurationDetails {
    const m = moment.duration(value, 'seconds');
    return { uId: '', days: Math.floor(m.asDays()), hours: m.hours(), minutes: m.minutes() };
  }

  getDurationFromDetails(days: number, hours: number, minutes: number): number {
    const m = moment(0).add(days, 'days').add(hours, 'hours').add(minutes, 'minutes');

    return m.unix();
  }

  getDurationDisplay(field: SchemaField, value: number): string {
    const format = !!field.settings?.format ? field.settings?.format : 'FORMAT-DURATION-FULL-NAMES';
    const details = this.getDurationDetailsFromValue(value);
    return this.translateService.instant(`FORMAT.${format}`, { d: details.days, h: details.hours, m: details.minutes });
  }
}
